import { FirebaseConnection } from './FirebaseConnection';

export class Config {
  apiKey?: string;
  authDomain?: string;
  databaseURL?: string;
  projectId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;

  public constructor(init?: Partial<Config>) {
    Object.assign(this, init);
  }

  public init(con: FirebaseConnection) {
    con.firebase.initializeApp({
      apiKey: this.apiKey,
      authDomain: this.authDomain,
      databaseURL: this.databaseURL,
      projectId: this.projectId,
      storageBucket: this.storageBucket,
      messagingSenderId: this.messagingSenderId,
      appId: this.appId
    });
  }
}